import { useRef } from 'react';

// A table view's inputs as they were when last fully loaded, so a refetch
// keeps the table up (under its loading overlay) instead of dropping back to
// a skeleton. Keep the rows and the colDefs in the one value, so the table
// never draws new columns over old rows. Undefined until the first load.
const useLastLoaded = <T>({
  value,
  isLoading,
}: {
  value: T;
  isLoading: boolean;
}): T | undefined => {
  const lastLoaded = useRef<T | undefined>(undefined);
  if (!isLoading) {
    lastLoaded.current = value;
  }
  return lastLoaded.current;
};

export default useLastLoaded;
